import Vue from "vue";
import VeeValidate from "vee-validate";
import VueValidationEs from "vee-validate/dist/locale/es";
import App from "./App.vue";

Vue.use(VeeValidate, {
  locale: "es",
  dictionary: {
    es: VueValidationEs
  }
});

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#app");
